<template>
  <modalCore
    v-if="visible"
    :title="title"
    :okText="okText"
    :okHref="okHref"
    :cancelText="cancelText"
    :cancelHref="cancelHref"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    {{ message }}
  </modalCore>
</template>

<script>
import modalCore from './modal-core'

export default {
  components: {
    modalCore,
  },

  data: () => ({
    visible: false,
    /** modal title */
    title: null,
    /** modal content */
    message: null,
    /** OK button text */
    okText: null,
    /** cancel button text */
    cancelText: null,
    /** OK button href */
    okHref: null,
    /** cancel button href */
    cancelHref: null,
  }),

  methods: {
    /**
     * @deprecated prefer to `.alert()`
     */
    show () {
      console.warn('`modal.show()` is deprecated prefer to `modal.alert()`')
      return this.alert.apply(this, arguments)
    },

    /**
     * the base method of `.alert()` and `.confirm()`.
     * do not use directly. use `.alert()` or `.confirm()` instead
     * @return {Promise<0 | 1 | void>} - 0: cancel, 1: ok, void: other
     */
    _show (message, options) {
      let { okText, cancelText } = options

      /**
       * if okText is `undefined` or `null`, default to 'OK'
       * if need to hide ok-button, set it to `false`
       */
      if (okText == null) {
        okText = 'OK'
      }

      if (cancelText == null) {
        cancelText = 'Cancel'
      }

      Object.assign(this, {
        ...options,

        message,
        okText,
        cancelText,
        visible: true,
      })

      this._resolve && this._resolve()

      return new Promise(resolve => {
        this._resolve = resolve
      })
    },

    /**
     * show a alert dialog with only one button.
     * like window.alert
     */
    alert (message, options = {}) {
      options.cancelText = false

      return this._show(message, options)
    },

    /**
     * show a confirm dialog with two button.
     * like window.confirm
     */
    confirm (message, options = {}) {
      return this._show(message, options)
    },

    /**
     * hide the dialog
     */
    hide (arg) {
      this.visible = false

      this._resolve && this._resolve(arg)
      this._resolve = null
    },

    /**
     * @private
     */
    handleOk (e) {
      this.hide(true)
    },

    /**
     * @private
     */
    handleCancel (e) {
      this.hide(false)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/_modal.vue